import script from "./index.vue?vue&type=script&setup=true&name=Breadcrumb&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Breadcrumb&lang=js"

import "./index.vue?vue&type=style&index=0&id=f459ca8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f459ca8a"]])

export default __exports__